/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantSecurityLevelResponse
 */
export interface TenantSecurityLevelResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecurityLevelResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    timezone?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantSecurityLevelResponse
     */
    levelValue?: number;
    /**
     * 
     * @type {Date}
     * @memberof TenantSecurityLevelResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TenantSecurityLevelResponse
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    errorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelResponse
     */
    errorDetails?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecurityLevelResponse
     */
    active?: boolean;
}

/**
 * Check if a given object implements the TenantSecurityLevelResponse interface.
 */
export function instanceOfTenantSecurityLevelResponse(value: object): value is TenantSecurityLevelResponse {
    return true;
}

export function TenantSecurityLevelResponseFromJSON(json: any): TenantSecurityLevelResponse {
    return TenantSecurityLevelResponseFromJSONTyped(json, false);
}

export function TenantSecurityLevelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSecurityLevelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'levelValue': json['levelValue'] == null ? undefined : json['levelValue'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'errorDetails': json['errorDetails'] == null ? undefined : json['errorDetails'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function TenantSecurityLevelResponseToJSON(json: any): TenantSecurityLevelResponse {
    return TenantSecurityLevelResponseToJSONTyped(json, false);
}

export function TenantSecurityLevelResponseToJSONTyped(value?: TenantSecurityLevelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'timezone': value['timezone'],
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'displayName': value['displayName'],
        'levelValue': value['levelValue'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'errorCode': value['errorCode'],
        'errorDetails': value['errorDetails'],
        'active': value['active'],
    };
}

